import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(private authService: AuthService) { }

  get isSaikiTubeReferenceUser(): boolean {
    return this.authService.isSaikiTubeReferenceUser;
  }

  get isVacantBedsReferenceUser(): boolean {
    return this.authService.isVacantBedsReferenceUser;
  }

  get isVacantBedsEditUser(): boolean {
    return this.authService.isVacantBedsEditUser;
  }

  get isAdmin(): boolean {
    return this.authService.isAdmin;
  }

  ngOnInit() { }
}
